import { Component, OnInit, Input } from '@angular/core';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
  useAnimation
} from '@angular/animations';
import { CommercialService } from '../../commercial.service';

@Component({
  selector: 'app-cq17',
  templateUrl: './cq17.component.html',
  styleUrls: ['./cq17.component.css', '../commercial-questionnaire.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ])
  ]
})
export class Cq17Component implements OnInit {

  @Input() data: any;
  question;
  questions;
  user_bot = false;
  showbutton = true;
  userResponses = [];
  index;
  questionObj;
  showTip = false;
  term_length;
  terms = [];
  deviceWidth;
  buttonText;
  disablebutton = false;
  timer;

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.userResponses = this.commercialService.userResponse.userResponses;
    this.deviceWidth = this.commercialService.deviceWidth;
    for (let i = 6; i <= 60;) {
      const obj =  i + ' Months';
      this.terms.push(obj);
      i = i + 6;
      if ( i > 36 && i < 60) {
        i = i + 6;
      }
    }
    const prepaidopt = 'I don\'t know';
    this.terms.push(prepaidopt);
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 1000);
    }
  }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'com_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.term_length = obj.fieldValue;
        if (!_.isEmpty(this.term_length)) {
          this.user_bot = true;
          if (this.deviceWidth < 768) {
            this.goNext();
          }
        }
      }
    }

    if(_.isEmpty(this.term_length))
    {
      this.showbutton = false;
    }
  }

  getTerm(event) {
    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({'currentId': this.data});
    }
    this.term_length = event;
    this.showTip = true;
    this.user_bot = true;
    this.save();
    if (this.deviceWidth < 768) {
      this.goNext();
    }else
    {
      if(!this.showbutton)
        {
          this.next();
        }
    }
  }
  next() {
    if (_.isEmpty(this.term_length)) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
    } else {
      this.commercialService.messageService({ 'currentId': this.data });
    }
  }

  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'com_question_id': this.data, 'fieldName': 'term_length', 'fieldValue': this.term_length
    };
    this.commercialService.updateResponses(Obj);
  }
}
